export enum RNPTabs {
  SYSTEM_ROLES = 'System Roles',
  CUSTOM_ROLES = 'Custom Roles',
}
